import React from "react";

import { FASetupRow } from "components/BudgetBuilder/Setup/FARateSetup/FASetupRow";
import LabelledComponent from "components/BudgetBuilder/Setup/LabelledComponent";
import RateTypeTable from "components/BudgetBuilder/Setup/RateTypeTable";
import Dropdown from "components/Dropdown";
import Table from "components/Table";
import { PERIOD_COUNT_OPTIONS } from "globals/constants";

import styles from "./styles.css";

const addOrRemovePeriodRows = (periodRows, newNumberOfPeriods) => {
	if (newNumberOfPeriods < periodRows.length) {
		return periodRows.filter(row => row.periodNumber <= newNumberOfPeriods);
	} else if (newNumberOfPeriods > periodRows.length) {
		let newPeriodRows = [ ...periodRows ];
		for (let periodNumber = periodRows.length; periodNumber < newNumberOfPeriods; periodNumber++) {
			newPeriodRows[periodNumber] = {
				periodNumber: periodNumber + 1,
				startDate: null,
				endDate: null,
				rateForPeriod: null,
			};
		}

		return newPeriodRows;
	}

	return periodRows;
};

const FARateSetup = ({ budgetPeriods, editable, rateType, onChange }) => {
	const periodRows = budgetPeriods.periodRows;
	const numberOfPeriods = budgetPeriods.numberOfPeriods;

	const handleNumberOfPeriodsChange = newNumberOfPeriods => {
		let newPeriodRows = addOrRemovePeriodRows(periodRows, newNumberOfPeriods);
		onChange({
			numberOfPeriods: newNumberOfPeriods,
			periodRows: newPeriodRows
		});
	};

	const onPeriodDataChange = (periodNumber, newData) => {
		let newPeriodRows = [ ...periodRows ];
		for (let i = 0; i < newPeriodRows.length; i++) {
			let newPeriodRow = newPeriodRows[i];
			if (newPeriodRow.periodNumber === periodNumber) {
				newPeriodRows[i] = newData;
				break;
			}
		}
		onChange({
			...budgetPeriods,
			periodRows: newPeriodRows
		});
	};


	return (
		<>
			<div className="ui grid">
				<div className="eight wide column">
					<LabelledComponent label={"Periods"}>
						{editable
							? (<Dropdown
								className={styles.dropdown}
								selection
								options={PERIOD_COUNT_OPTIONS}
								placeholder={"Rate Types"}
								onChange={(event, { value }) => handleNumberOfPeriodsChange(value)}
								value={numberOfPeriods}
							   />
							)
							: numberOfPeriods
						}
					</LabelledComponent>
				</div>
				<div className="eight wide column">
					<div className={styles.rateTableLabel}>
						<span>{"Selected Rate Type Table"}</span>
					</div>
				</div>
			</div>
			<div className="ui grid">
				<div className="eight wide column">
					<Table overflow={"visible"} captionText="FA Rate">
						<Table.Header>
							<Table.Row>
								<Table.HeaderCell/>
								<Table.HeaderCell>{"Period Start Date"}</Table.HeaderCell>
								<Table.HeaderCell>{"Period End Date"}</Table.HeaderCell>
								<Table.HeaderCell>{"FA Rate for Period"}</Table.HeaderCell>
							</Table.Row>
						</Table.Header>
						<Table.Body>
							{periodRows.map((period, index) => (
								<FASetupRow
									key={index}
									editable={editable}
									period={period}
									onChange={newData => onPeriodDataChange(period.periodNumber, newData)}
								/>
							))}
						</Table.Body>
					</Table>
				</div>
				<div className="eight wide column">
					<RateTypeTable selectedRate={rateType} />
				</div>
			</div>
		</>
	);
};

export default FARateSetup;
